import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.styl']
})
export class FooterComponent implements OnInit {

  public year;

  constructor() { }

  ngOnInit() {
    var year = new Date();
    this.year = year.getFullYear();
  }

}
